export const SEARCH_MOVIES = 'SEARCH_MOVIES';
export const RATING_MOVIES = 'RATING_MOVIES';
export const FETCH_SEARCH_MOVIES = 'FETCH_SEARCH_MOVIES';
export const FETCH_POPULAR_MOVIES = 'FETCH_POPULAR_MOVIES';
export const FETCH_MOVIE = 'FETCH_MOVIE';
export const LOADING = 'LOADING';